import { lang } from '@umu/ukit-lang';
/**
 * @description 底部出现的分享选项浮层
 */

import './tiedShareOptions.scss';

import { ETiedShareType } from '@umu/umu-types';
import React, { Component } from 'react';
import { $window } from '@umu/umu-dom';
import { components } from 'common';
const { Portal } = components;
import shareToClassService, { IShareToClassPageParams } from '../../services/shareToClassService';

enum SHART_TYPE_LABEL_MAP {
    SHARE_CARD = lang('生成邀请卡'),
    SHARE_TO_CLASS_PAGE = lang('分享到班级'),
}

enum SHART_TYPE_ICON_MAP {
    SHARE_CARD = 'card',
    SHARE_TO_CLASS_PAGE = 'class',
}

interface IShareOption {
    type: ETiedShareType;
    target: {
        url?: string;
        shareToClassPageParams?: IShareToClassPageParams;
    };
}

interface IProps {
    options: IShareOption[][];
    close: () => void;
    isShow: boolean;
}

interface IState {
    isRendered: boolean;
}

export default class TiedShareOptions extends Component<IProps, IState> {
    private activeTimer: number = 0;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isRendered: false,
        };
    }

    public clearActiveTimer = () => {
        clearTimeout(this.activeTimer);
    };

    public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.isShow && !this.props.isShow) {
            this.clearActiveTimer();
            this.activeTimer = $window.setTimeout(() => {
                this.setState({
                    isRendered: true,
                });
            }, 10);
        } else {
            this.setState({
                isRendered: false,
            });
        }
    }

    public componentWillUnmount() {
        this.clearActiveTimer();
    }

    /**
     * @param {object} option
     * type: 'SHARE_CARD',
     * target: {
     *     url: this.props.sharePageUrl,
     *     // 其它字段对应逻辑
     * },
     *
     */
    public getOptionItem(option: IShareOption, index: number) {
        return (
            <div className="option-item" key={index} onClick={this.getOptionTarget(option)}>
                <div className={`share-icon share-icon-${SHART_TYPE_ICON_MAP[option.type]}`}></div>
                <div className="label">{SHART_TYPE_LABEL_MAP[option.type]}</div>
            </div>
        );
    }

    public getOptionTarget(option: IShareOption) {
        const type = option.type;
        const target = option.target;
        if (!target) {
            return () => null;
        }

        let url = target.url || '';
        if (!url) {
            if (type === ETiedShareType.SHARE_TO_CLASS_PAGE && target.shareToClassPageParams) {
                url = shareToClassService.goToSharePage(target.shareToClassPageParams);
            }
        }

        return () => {
            window.location.href = url;
        };
    }

    public render() {
        if (!this.props.isShow) {
            return null;
        }
        const options = this.props.options;

        return (
            <Portal preventBodyScroll={true}>
                <div className="tied-share-options">
                    <div className="doc-fixed top bottom">
                        <div className="options-mask" onClick={this.props.close}></div>
                    </div>
                    <div className="doc-fixed bottom filled">
                        <div className={'options-main' + (this.state.isRendered ? ' active' : '')}>
                            <div className="option-list">
                                {options.map((optionRow, rowIndex) => {
                                    return (
                                        <div className="option-list-row" key={rowIndex}>
                                            {optionRow.map((option, optionIndex) => {
                                                return this.getOptionItem(option, optionIndex);
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
}
